import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import withStyles from '@material-ui/core/styles/withStyles';
import isObject from 'lodash/isObject';

import styles from './styles';

function ADGMSnackbar(props) {
  const { classes, severity, message, onClose } = props;
  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    setShowSnackbar(true);
  }, [isObject(message) ? message?.props?.id : message]);

  const onCloseHandler = () => {
    setShowSnackbar(false);
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <Snackbar
      open={showSnackbar}
      autoHideDuration={4000}
      onClose={onCloseHandler}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      className={classes.snackbar}
    >
      <MuiAlert severity={severity} className={classes.errorColor} elevation={6} variant='filled'>
        {message}
      </MuiAlert>
    </Snackbar>
  );
}

ADGMSnackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  severity: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClose: PropTypes.func,
};

ADGMSnackbar.defaultProps = {
  severity: 'error',
  onClose: null,
};

export default withStyles(styles)(ADGMSnackbar);
